export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7fc0b3e6400077fefed82f58aa770801d8e719a5d8&name=apiMindbox!'